var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSiglive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_2131_17459_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.024 -0.024 0 24 24)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1020,
    y: -1020,
    width: 2040,
    height: 2040
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(70, 143, 234, 1) 183.6deg,rgba(70, 143, 234, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM7.17664 24C7.17664 33.2913 14.7087 40.8234 24 40.8234C33.2913 40.8234 40.8234 33.2913 40.8234 24C40.8234 14.7087 33.2913 7.17664 24 7.17664C14.7087 7.17664 7.17664 14.7087 7.17664 24Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.27450981736183167,\"g\":0.56078433990478516,\"b\":0.91764706373214722,\"a\":1.0},\"position\":0.50999999046325684},{\"color\":{\"r\":0.27450981736183167,\"g\":0.56078433990478516,\"b\":0.91764706373214722,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.27450981736183167,\"g\":0.56078433990478516,\"b\":0.91764706373214722,\"a\":1.0},\"position\":0.50999999046325684},{\"color\":{\"r\":0.27450981736183167,\"g\":0.56078433990478516,\"b\":0.91764706373214722,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":2.9391526579626397e-15,\"m01\":-48.000003814697266,\"m02\":48.000003814697266,\"m10\":48.000003814697266,\"m11\":2.9391526579626397e-15,\"m12\":-2.9391526579626397e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2406,
    cy: 44.3998,
    r: 3.6,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_2131_17459_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM7.17664 24C7.17664 33.2913 14.7087 40.8234 24 40.8234C33.2913 40.8234 40.8234 33.2913 40.8234 24C40.8234 14.7087 33.2913 7.17664 24 7.17664C14.7087 7.17664 7.17664 14.7087 7.17664 24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSiglive);
export default __webpack_public_path__ + "static/media/loading-siglive.1a52c8bb62d79403aed7a15ad13aa430.svg";
export { ForwardRef as ReactComponent };